import { useEffect, useMemo, useState } from "react"
import { dateConvert } from "../../../utils/Helper"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { useEmployeFilter } from "../../../context/EmployeFilterContext"

export const useLeadEmpStatus = () => {

    const { selectedEmployee } = useEmployeFilter();
    const [filterValues, setFilterValues] = useState({date: new Date()});
    const [loader, setLoader] = useState(false);
    const [cards, setCards] = useState([
        { key: "total_employee", label: "Total Employees", icon: "users" },
        { key: "on_site", label: "On Site", icon: "building" },
        { key: "wfh", label: "WFH", icon: "house-laptop" },
        { key: "on_leave", label: "On Leave", icon: "calendar-check" },
        { key: "without_inform", label: "Without Inform", icon: "warning" },
    ])
    const [data, setData] = useState({});

    useEffect(() => {
        selectedEmployee?.user_code && getAttendanceSummary();
    }, [selectedEmployee, filterValues?.date])

    const getAttendanceSummary = async () => {
            try {
                setLoader(true);
                const payload = {
                    "date": dateConvert(filterValues?.date, "iso-string"),
                    "project_lead_user_code": selectedEmployee?.user_code || 0,
                };
                const res = await services.getInvokeRemote("POST", Urls("GETTEAMATTENDANCESUMMARY"), payload)
                if (res) {
                    const data = res?.body?.data?.manager_team_attandance_summary?.[0];
                    setData(data);
                    setLoader(false);
                }
            } catch (error) {
                console.error("error: ", error);
                setLoader(false);
            }
        }

    const handleDateChange = async (count) => {
        const date = new Date(filterValues?.date);
        date.setDate(date.getDate() + count)
        setFilterValues((prev) => ({...prev, date: date}));
    }

    return useMemo(() => ({
        cards, data, handleDateChange, filterValues, setFilterValues, loader
    }), [cards, data, handleDateChange, filterValues, setFilterValues, loader])
}